import { loadStripe } from "@stripe/stripe-js";
import { createSubscriptionCheckoutSessionWithTrial } from "./audiblogsApi";
const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(STRIPE_API_KEY);

export const createStripeSessionAndRedirectToCheckout = (
  idToken,
  articleUrl = ""
) => {
  stripePromise.then((stripe) => {
    createSubscriptionCheckoutSessionWithTrial(true, idToken)
      .then(function (data) {
        stripe
          .redirectToCheckout({
            sessionId: data.data.sessionId,
          })
          .then((handleResult) => {
            console.log("handle results");
            handleResult();
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
        // alert("Something went wrong. Please try again or contact us.");
      });
  });
};
